module.exports = __webpack_public_path__ + "static/huawei-store-8cfa6f7d457d64253f1683386b8d4726.png";